<script>
import * as moment from "moment";

export default {
  props: {
    start: {
      type: [Date, Number, String],
      default: null
    },
    end: {
      type: [Date, Number, String],
      default: null
    },
    type: {
      type: String,
      default: "date"
    }
  },
  watch: {
    startEnd: {
      handler: function(val) {
        // This is just for calling the computed when value changes
      },
      deep: true
    }
  },
  computed: {
    startEnd() {
      const { start, end } = this;
      if (start && end) {
        if (this.type === "date") {
          const a = moment(start);
          const b = moment(end);
          this.$emit("calc", b.diff(a, "months"));
        }
      }
      return {
        start,
        end
      };
    }
  }
};
</script>

<template>
  <div></div>
</template>
